import moment from "moment";
import {CUSTOMER_SHIFTS_TABS} from "constants/constants";

export const CUSTOMER_SHIFTS_PAGE_SIZE = 10;

export const formatDateValue = dateValue => {
    if (!dateValue) return undefined;

    if (typeof dateValue === "string") {
        return dateValue.split("T")[0] || undefined;
    }

    return moment(dateValue).format("YYYY-MM-DD");
};

const buildPaginationParams = currentPage => ({
    limit: CUSTOMER_SHIFTS_PAGE_SIZE,
    skip: (currentPage - 1) * CUSTOMER_SHIFTS_PAGE_SIZE
});

export const buildActivePoolShiftParams = (subcompanyId, currentPage = 1) => ({
    subcompanyId,
    ...buildPaginationParams(currentPage)
});

export const buildDatedPoolShiftParams = (subcompanyId, filters, currentPage = 1) => {
    const params = {
        subcompanyId,
        ...buildPaginationParams(currentPage)
    };
    const startDate = formatDateValue(filters?.startDate);
    const endDate = formatDateValue(filters?.endDate);

    if (startDate) {
        params.startDate = startDate;
    }

    if (endDate) {
        params.endDate = endDate;
    }

    return params;
};

export const buildShiftCountParams = (subcompanyId, tabKey, plannedFilters, completedFilters) => {
    const params = {subcompanyId};

    const sourceFilters =
        tabKey === CUSTOMER_SHIFTS_TABS.PLANNED
            ? plannedFilters
            : tabKey === CUSTOMER_SHIFTS_TABS.COMPLETED
            ? completedFilters
            : null;

    if (sourceFilters) {
        const startDate = formatDateValue(sourceFilters?.startDate);
        const endDate = formatDateValue(sourceFilters?.endDate);

        if (startDate) {
            params.startDate = startDate;
        }

        if (endDate) {
            params.endDate = endDate;
        }
    }

    return params;
};

export const createCompletedDateFilters = (subCompanyId, overrides = {}) => ({
    subCompany: subCompanyId ? [subCompanyId] : undefined,
    startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    ...overrides
});

export const createPlannedDateFilters = (subCompanyId, overrides = {}) => ({
    subCompany: subCompanyId ? [subCompanyId] : undefined,
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().add(1, "month").format("YYYY-MM-DD"),
    ...overrides
});

export const normalizePoolShiftList = response => {
    if (!response || response === false) {
        return {rows: [], dataCount: 0};
    }

    const payload = response?.result ?? response?.data ?? response;
    const rows = Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload?.rows)
        ? payload.rows
        : [];

    return {
        rows,
        dataCount: payload?.dataCount ?? rows.length
    };
};

export const normalizeShiftCounts = response => {
    if (!response || response === false) {
        return {activeCount: 0, plannedCount: 0, completedCount: 0};
    }

    const data = response?.result ?? response?.data ?? response ?? {};

    return {
        activeCount: data.activePoolShiftCounts ?? 0,
        plannedCount: data.plannedPoolShiftCounts ?? 0,
        completedCount: data.completedPoolShiftCounts ?? 0
    };
};
